import React from 'react';
import Page from '../../containers/page';
import RouteComponent from '../../helpers/route';
import ExternalApiLogs from '../../components/externalApiLogs';

const FILTER_KEYS = [
    'preset', 'customFrom', 'customTo', 'clientId', 'clientLabel', 'apiKeyId', 'apiKeyLabel',
    'route', 'method', 'path', 'statusClass', 'status', 'minDurationMs', 'fingerprint',
    'requestId', 'bodyHash', 'ip', 'authMethod', 'authErrorCode', 'authenticated', 'replica',
    'sortField', 'sortType', 'page', 'entries',
];

class Screen extends RouteComponent {
    _initialFilters = () => {
        let params = this._getParams();
        let filters = {};
        FILTER_KEYS.forEach((key) => { filters[key] = params[key] !== undefined ? params[key] : ''; });
        return filters;
    }

    _onFiltersChange = (filters) => {
        this.updateMultipleParams(FILTER_KEYS.map((key) => ({ name: key, value: filters[key] })), false);
    }

    render() {
        return (
            <div>
                <div className="section-title title-options">
                    <h1>{'External API Logs'.translate(this.props.lang)}</h1>
                </div>

                <ExternalApiLogs
                    lang={this.props.lang}
                    initialFilters={this._initialFilters()}
                    onFiltersChange={this._onFiltersChange}
                />
            </div>
        );
    }
}

export default Page(Screen);
